export const DEFAULT_LOCALE = "en-IN"

/**
 *
 * 5000.657 -> ₹5,000.66
 * @description Displays clean and readable currency in Indian Rupees
 */
export const inr = new Intl.NumberFormat(DEFAULT_LOCALE, {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
}).format
